import { useForm } from '@/Hooks/useFormWrapper';
import { useRequired } from '@/Hooks/Validation';
import { OrderWarehouseInfo } from '@/Models/Order/OrderWarehouseInfo';
import { shippingLabelModalActions } from '@/ModalWindows/ShippingLabelModal/services';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { useDispatch } from 'react-redux';

export type FormData = {
  warehouseId: number;
};

export const useSelectWarehouseForm = (orderWarehouseInfos: OrderWarehouseInfo[]) => {
  const dispatch: AppDispatch = useDispatch();

  const { register, handleSubmit } = useForm<FormData>();

  const required = useRequired();

  const onSubmit = handleSubmit(({ warehouseId }) => {
    const orderIds = orderWarehouseInfos
      .filter((item) => {
        return item.warehouseId == warehouseId;
      })
      .map((item) => item.orderId);

    dispatch(shippingLabelModalActions.setFilteredOrderIds(orderIds));
  });

  return {
    methods: {
      register,
      onSubmit,
    },
    rules: {
      required,
    },
  };
};
